import * as React from 'react';
import type { SVGProps } from 'react';
const SvgApplications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.632 6.704a1.073 1.073 0 1 0 0-2.146 1.073 1.073 0 0 0 0 2.146m0 2.28a3.352 3.352 0 1 0 0-6.705 3.352 3.352 0 0 0 0 6.704Zm0 5.766a1.073 1.073 0 1 0 0-2.145 1.073 1.073 0 0 0 0 2.146Zm0 2.28a3.352 3.352 0 1 0 0-6.704 3.352 3.352 0 0 0 0 6.704m0 5.767a1.073 1.073 0 1 0 0-2.146 1.073 1.073 0 0 0 0 2.146m0 2.279a3.352 3.352 0 1 0 0-6.705 3.352 3.352 0 0 0 0 6.705m8.046-18.372a1.073 1.073 0 1 0 0-2.146 1.073 1.073 0 0 0 0 2.146m0 2.28a3.352 3.352 0 1 0 0-6.705 3.352 3.352 0 0 0 0 6.704Zm0 5.766a1.073 1.073 0 1 0 0-2.145 1.073 1.073 0 0 0 0 2.146Zm0 2.28a3.352 3.352 0 1 0 0-6.704 3.352 3.352 0 0 0 0 6.704m0 5.767a1.073 1.073 0 1 0 0-2.146 1.073 1.073 0 0 0 0 2.146m0 2.279a3.352 3.352 0 1 0 0-6.704 3.352 3.352 0 0 0 0 6.704m8.045-18.372a1.073 1.073 0 1 0 0-2.146 1.073 1.073 0 0 0 0 2.146m0 2.28a3.352 3.352 0 1 0 0-6.705 3.352 3.352 0 0 0 0 6.704Zm0 5.766a1.073 1.073 0 1 0 0-2.145 1.073 1.073 0 0 0 0 2.146Zm0 2.28a3.352 3.352 0 1 0 0-6.704 3.352 3.352 0 0 0 0 6.704m0 5.767a1.073 1.073 0 1 0 0-2.146 1.073 1.073 0 0 0 0 2.146m0 2.279a3.352 3.352 0 1 0 0-6.704 3.352 3.352 0 0 0 0 6.704"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgApplications;
